<template>
  <v-card
    height="100%"
    max-width = "220"
    flat tile
    class="blogger-home-card"
  >
    <v-navigation-drawer
      v-model="drawerShow"
      :color="'#121212'"
      :mini-variant="miniVariant"
      :expand-on-hover="expandHover"
      :permanent="true" dark
      hide-overlay absolute
    >
      <v-list dense nav active active-class="#9CCC65">
        <!-- 头像 签名 座右铭 -->
        <v-list-item two-line class="px-0" link @click="itemClick({path:'/blog/tags'})">
          <v-list-item-avatar class="blogger-avatar"><img :src="avatar"></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="name-cls">{{ author }}</v-list-item-title>
            <v-list-item-subtitle><p>{{ motto }}</p></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item link @click="itemClick({path:'/schedule'})">
            <v-list-item-avatar size="27"><img :src="GANTE" /></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>日程表</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <!-- 个人项目 快捷链接 -->
        <v-list-item-group color="success">
          <v-list-item
            v-for="(item, i) in items"
            :key="i" link
            @click="itemClick(item)"
          >
            <v-list-item-avatar size="27"><img :src="item.avatar"></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-divider></v-divider>
        <!-- 分类 快捷链接 -->
        <v-list-group
          :value="false"
          :expand='true'
          color="success"
          prepend-icon="mdi-currency-usd"
          v-if="pythonTitleTotal || javaTitleTotal || dbTitleTotal"
          >
            <!-- 后端 -->
          <template v-slot:activator>
            <v-list-item-title>后端技巧</v-list-item-title>
          </template>

          <v-list-item v-if="pythonTitleTotal > 0" link @click="categoryClick('python')">
            <v-list-item-avatar size="27"><img :src="PYTHON" /></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Python</v-list-item-title>
            </v-list-item-content>
            <v-avatar size="16" ><i class="redNum">{{ pythonTitleTotal }}</i></v-avatar>
          </v-list-item>
          <v-list-item v-if="javaTitleTotal > 0" link @click="categoryClick('java')">
            <v-list-item-avatar size="27"><img :src="JAVA" /></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Java</v-list-item-title>
            </v-list-item-content>
            <v-avatar size="16" ><i class="redNum">{{ javaTitleTotal }}</i></v-avatar>
          </v-list-item>
          <v-list-item v-if="dbTitleTotal > 0" link @click="categoryClick('db')">
            <v-list-item-avatar size="27"><img :src="MONGO" /></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>数据库</v-list-item-title>
            </v-list-item-content>
            <v-avatar size="16" ><i class="redNum">{{ dbTitleTotal }}</i></v-avatar>
          </v-list-item>
        </v-list-group>

        <!-- 前端 -->
        <v-list-group
          :value="false"
          :expand='true'
          color="success"
          prepend-icon="mdi-currency-cny"
          v-if="vueTitleTotal || jsTitleTotal"
          >
            <template v-slot:activator>
              <v-list-item-title>前端技能</v-list-item-title>
            </template>

          <v-list-item v-if="vueTitleTotal > 0" link @click="categoryClick('vue')">
            <v-list-item-avatar size="27"><img :src="VUE" /></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>Vue</v-list-item-title>
            </v-list-item-content>
            <v-avatar size="16" ><i class="redNum">{{ vueTitleTotal }}</i></v-avatar>
          </v-list-item>
          </v-list-item>
          <v-list-item v-if="jsTitleTotal > 0" link @click="categoryClick('js')">
            <v-list-item-avatar size="27"><img :src="JS" /></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>JS</v-list-item-title>
            </v-list-item-content>
            <v-avatar size="16" ><i class="redNum">{{ jsTitleTotal }}</i></v-avatar>
          </v-list-item>
        </v-list-group>

        <!-- 前沿技术 -->
        <v-list-group
          :value="false"
          :expand='true'
          color="success"
          prepend-icon="mdi-currency-btc"
          v-if="bigdataTitleTotal || deeplearnTitleTotal"
          >
            <template v-slot:activator>
              <v-list-item-title>前沿技术</v-list-item-title>
            </template>

          <v-list-item v-if="bigdataTitleTotal > 0" link @click="categoryClick('bigdata')">
            <v-list-item-avatar height="32" width="32"><img :src="BIGDATA" /></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>大数据</v-list-item-title>
            </v-list-item-content>
            <v-avatar size="16" ><i class="redNum">{{ bigdataTitleTotal }}</i></v-avatar>
          </v-list-item>
          <v-list-item v-if="deeplearnTitleTotal > 0" link @click="categoryClick('deeplearn')">
            <v-list-item-avatar height="32" width="32"><img :src="AI" /></v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>深度学习</v-list-item-title>
            </v-list-item-content>
            <v-avatar size="16" ><i class="redNum">{{ deeplearnTitleTotal }}</i></v-avatar>
          </v-list-item>
        </v-list-group>

        <v-divider></v-divider>
        <!-- 时间，地理位置 -->
        <v-list-item three-line>
          <v-list-item-avatar color="#81D4FA" size="27">{{ localCity }}</v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ nowTime }} </v-list-item-title>
            <v-list-item-subtitle>{{ nowDate }} {{ nowWeek }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-list-item three-line v-show="todayWeather">
          <!-- 今日天气 -->
          <v-list-item-avatar size="27"><img :src="todayImg"></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle v-html="todayWeather"> </v-list-item-subtitle>
            <v-list-item-subtitle v-html="todayTemperature"> </v-list-item-subtitle>
          </v-list-item-content>
          <!-- 明日天气 -->
          <v-list-item-avatar size="32"><img :src="tomorrowImg"></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle v-html="tomorrowWeather"> </v-list-item-subtitle>
            <v-list-item-subtitle v-html="tomorrowTemperature"> </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link @click="itemClick({path:'/blog/wechat'})">
          <v-list-item-avatar size="27"><img :src="PAY"></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>打赏一下~</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
  import CONFIG from '@/config/config.js';
  // 博文类别
  import GANTE from '@/assets/imgs/nav/gante.png'
  import TAG from '@/assets/imgs/nav/tag.png'
  import PAY from '@/assets/imgs/nav/pay.png'
  import FOOT from "@/assets/imgs/nav/foot.png"
  import AXIS from '@/assets/imgs/nav/axis.png'
  import MAYBE from '@/assets/imgs/nav/maybe.png'
  import LOVETALK from '@/assets/imgs/nav/lovetalk.png'
  import INTERVIEW from '@/assets/imgs/nav/interview.png'
  import RESUME from '@/assets/imgs/nav/center_ic_resume.png'

  // 技术栈
  import AI from '@/assets/imgs/nav/ai.png'
  import VUE from '@/assets/imgs/nav/vue.png'
  import JAVA from '@/assets/imgs/nav/java.png'
  import JS from '@/assets/imgs/nav/Nodejs.png'
  import PYTHON from '@/assets/imgs/nav/python.png'
  import MONGO from '@/assets/imgs/nav/mongodb.png'
  import BIGDATA from '@/assets/imgs/nav/bigdata.png'

  export default {
    name: 'blogHome',
    props: {
      color:{
        type: String,
        default:"#4CAF50"
      },
    },
    data () {
      return {
        AI,
        JS,
        PAY,
        VUE,
        JAVA,
        GANTE,
        MONGO,
        PYTHON, 
        BIGDATA,
        // 侧边栏设置
        drawerShow: true,
        miniVariant: true,
        expandHover:true,
        avatar:CONFIG.LOGO,
        motto:CONFIG.MOTTO,
        author:CONFIG.AUTHOR,
        title:CONFIG.TITLE,
        // 时间，天气
        _timer:null,
        todayImg:"",
        todayWeather:"",
        todayTemperature:"",
        tomorrowImg:"",
        tomorrowWeather:"",
        tomorrowTemperature:"",
        localCity: "杭州",
        localCountry:"中国",
        localToday:"",
        nowWeek:"",
        nowDate:"",
        nowTime:"",
        // 博文分类
        items:[
          {
            avatar:FOOT,
            title:"足迹",
            path:"/blog/traval"
          },
          {
            avatar:AXIS,
            title:"时间轴",
            path:"/blog/time-line"
          },
          // {
          //   avatar:TAG,
          //   title:"标签云",
          //   path:"/tags"
          // },
          {
            avatar:RESUME,
            title:"个人简历",
            path:"/about-me"
          },
          {
            avatar:MAYBE,
            title:"Maybe",
            path:"https://github.com/HalfLeaf/maybe"
          },
          {
            avatar:INTERVIEW,
            title:"INTERVIEW",
            path:"https://github.com/HalfLeaf/interview"
          },
          {
            avatar:LOVETALK,
            title:"cheer-on",
            path:"/cheer-on"
          },
        ],
        // 博文数量统计
        pythonTitleTotal:0,
        javaTitleTotal:0,
        dbTitleTotal:0,
        vueTitleTotal:0,
        jsTitleTotal:0,
        bigdataTitleTotal:0,
        deeplearnTitleTotal:0,
      }
    },
    computed: {},
    filters: {
      getFirstStr(value){
        value = value || "杭州";
        return value.substr(0, 1)
      },
    },
    methods:{
      // 列表项点击事件
      itemClick(item){
        let url = item.path;
        if (/https?:/.test(url)){
          window.open(url, "_blank");
        }else{
          this.$router.push({path:url})
        }
      },
      // 获取日期
      getDate() {
        let _this = this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth() + 1;
        let dd = new Date().getDate();
        let week = new Date().getDay();
        let hh = new Date().getHours();
        let _mf = new Date().getMinutes();
        let mf = _mf< 10? "0"+_mf: _mf;
        let _ss = new Date().getSeconds();
        let ss = _ss < 10? "0"+_ss: _ss;
        if (week == 1) {
            this.nowWeek = "周一";
        } else if (week == 2) {
            this.nowWeek = "周二";
        } else if (week == 3) {
            this.nowWeek = "周三";
        } else if (week == 4) {
            this.nowWeek = "周四";
        } else if (week == 5) {
            this.nowWeek = "周五";
        } else if (week == 6) {
            this.nowWeek = "周六";
        } else {
            this.nowWeek = "周日";
        }
        _this.nowDate = yy + "-" + mm + "-" + dd;
        _this.nowTime =  hh + ":" + mf + ":" + ss;
      },
      // 获取本地天气
      getWeather() {
        let _this = this;
        _this.localCity = _this.$store.state.localWeather.localCity;
        _this.localCountry = _this.$store.state.localWeather.localCountry;
        _this.todayImg = _this.$store.state.localWeather.todayImg;
        _this.todayWeather = _this.$store.state.localWeather.todayWeather;
        _this.todayTemperature = _this.$store.state.localWeather.todayTemperature;
        _this.tomorrowImg = _this.$store.state.localWeather.tomorrowImg;
        _this.tomorrowWeather = _this.$store.state.localWeather.tomorrowWeather;
        _this.tomorrowTemperature = _this.$store.state.localWeather.tomorrowTemperature;
      },
      // 博文统计
      blogTotal(){
        let _this = this;
        let data = this.$store.state.articlesTotal;
        _this.pythonTitleTotal = data['python'];
        _this.javaTitleTotal = data['java'];
        _this.dbTitleTotal = data['数据库'];
        _this.vueTitleTotal = data['vue'];
        _this.jsTitleTotal = data['js'];
        _this.bigdataTitleTotal = data['大数据'];
        _this.deeplearnTitleTotal = data['深度学习'];
      },
      // 分类栏点击事件
      categoryClick(item){
        this.$router.push({path:'/blog/category', query:{type:item}})
      },
    },
    created(){
      let _this = this;
      _this.blogTotal();
      _this.getDate();
      _this.getWeather();
      if (_this._timer) clearInterval(_this._timer);
      this._timer = setInterval(() => {
        this.getDate();
      }, 1000); 
    },
    destroyed() {
      if (this._timer) clearInterval(this._timer);
    }
  }
</script>
<style lang="stylus" scoped>
.blogger-home-card
  overflow  auto
  width 100%
  height  100%
  position absolute
  left  0
  top  0
  border none

.redNum
  color #FB8C00
  font-size 10px
  size 10px

.name-cls
  margin-left 16%
  font-weight 700
  font-size 18px

</style>
